import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetCountries } from '../interfaces/country.interface';
import { ControlerEnum } from '../enums/controler.enum';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  apiBaseUrl: string = environment.apiBaseUrl;
  private http = inject(HttpClient);

  getCountries(): Observable<HttpResponse<IGetCountries>> {
    return this.http.get<IGetCountries>(
      `${this.apiBaseUrl}/${ControlerEnum.Country}`,
      { observe: 'response' },
    );
  }

  changeCountry(
    countryId: number,
    refreshToken: string,
  ): Observable<HttpResponse<any>> {
    const model = {
      countryId: countryId,
      refreshToken: refreshToken,
    };
    return this.http.post<any>(
      `${this.apiBaseUrl}/${ControlerEnum.Country}/changeCountry`,
      model,
      { observe: 'response' },
    );
  }
}
